import type { AppData } from '../../types/app_data';

import type { AnalyticsUser } from './types';

/**
 * Set up externalId and optOut for Reddit Pixel.
 */
const initRedditPixelConfig = (userID: string, enableLDU: boolean): void => {
  if (window.rdt && window.redditPixelID) {
    window.rdt('init', window.redditPixelID, {
      externalId: userID,
      optOut: enableLDU ? 1 : undefined,
    });
  }
};

/**
 * Identify user to Reddit Pixel.
 *
 * @param user
 */
export const setUserForRedditPixel = async (user: AnalyticsUser): Promise<void> => {
  initRedditPixelConfig(user.id, !!user.enableLDU);
};

/**
 * Track signup conversion.
 */
export const trackSignedUpForReddit = (appData?: AppData): void => {
  if (window.rdt) {
    if (appData?.id && appData?.enableLDU) {
      initRedditPixelConfig(appData.id, !!appData.enableLDU);
    }

    window.rdt('track', 'SignUp');
  }
};

/**
 * Track onboarded conversion.
 */
export const trackOnboardedForReddit = (appData?: AppData): void => {
  if (window.rdt) {
    if (appData?.id && appData?.enableLDU) {
      initRedditPixelConfig(appData.id, !!appData.enableLDU);
    }

    window.rdt('track', 'AddToCart');
  }
};
